import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask w-full h-full"
}
const _hoisted_2 = { class: "modal-body mtop-10" }
const _hoisted_3 = {
  key: 0,
  class: "row w-full"
}
const _hoisted_4 = { class: "col-0-8 colend mright-04" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "row w-full mtop-10" }
const _hoisted_7 = { class: "col-0-8 colend mright-04" }
const _hoisted_8 = { class: "row w-full mtop-10" }
const _hoisted_9 = { class: "col-0-8 colend mright-04" }

import { ref, watch } from "vue";
import { useI18n } from 'vue-i18n';
import { SettingsApi, TimeslotRequest } from '@/apiGenerate/medserver';
import { ApiError, DateFormat } from "@/models/share.model";
import { format, parse } from "date-fns";
import { toastError, toastSuccess } from "@/utils/toast-utils";
import { useToast } from "primevue";
import { medServerApiConfig } from "@/config/medserver-api.config";


export default /*@__PURE__*/_defineComponent({
  __name: 'esTimeslotForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    timeslotId: {},
    start: {},
    end: {},
    isSameDate: { type: Boolean },
    max: {},
    min: {},
    isSetting: { type: Boolean },
    displayDeleteButton: { type: Boolean },
    selectedInstituteId: {},
    selectedAppointmentTypeId: {},
    selectedDayModelId: {}
  },
  emits: ["modal-close", "delete-action"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();
const toast = useToast();

const settingsApi = new SettingsApi(medServerApiConfig);

const target = ref(null);
const deleteAction = ref<boolean>(false);

const timeslotRequest = ref<TimeslotRequest>({
  timeslotId: null,
  start:null,
  end:null
});

const isSameHour = ref<boolean>(true);

/**
 * format the result date attributes to utc format
 *
 * @param timeslotRequest the timeslotRequest to convert the date attributes to utc format
 * @return a timeslotRequest with formatted date attributes
 */
const formatResultToUtc = (timeslotRequest: TimeslotRequest) => {
  return {
    timeslotId: timeslotRequest.timeslotId,
    start: timeslotRequest.start + ':00',
    end: timeslotRequest.end + ':00'
  }
}

const confirmFormModal = async () => {
  if (timeslotRequest.value) {
    const timeslotRequestFormatted: TimeslotRequest = formatResultToUtc(timeslotRequest.value);

    if (deleteAction.value) {
      emit('delete-action', timeslotRequestFormatted);
    } else {
      if (props.selectedAppointmentTypeId && props.selectedDayModelId) {
        await settingsApi.addUpdateSlotDayModelById({instituteId: props.selectedInstituteId, daymodelId:  props.selectedDayModelId, appointmentTypeId: props.selectedAppointmentTypeId, timeslotRequest: timeslotRequestFormatted}).then(() => {
          toastSuccess(toast, {
              summary: t('common.toast.success.update'),
              detail:  t('settings.label.dayModel.form.message.success.timeslot')
          });
          emit('modal-close', timeslotRequestFormatted);
        }).catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error?.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });   
          // Throw error to set at false the var __alreadyClicked in v-one-click directive
          throw error;
        });
      } else {
        // Case : update timeslot since esCalendarSettings component
        emit('modal-close', timeslotRequestFormatted);
      }
    }  
  }  
}

const closeFormModal = () => {
    emit('modal-close');
}

const updateDeleteAction = () => {
  deleteAction.value = !deleteAction.value;
}

const getDateTime = (time: string): Date => {
  return new Date(format(new Date(), DateFormat.ISO_SMALL) + " " + time);
}

const updateTime = (time: Date, isEnd: boolean) => {
  if (isEnd) {
    timeslotRequest.value.end = format(time, DateFormat.TIME_SMALL);
  } else {
    timeslotRequest.value.start = format(time, DateFormat.TIME_SMALL);
  }

  isSameHours();
  if(!isSameHour.value){
    isHourValid();
  }
}

const isSameHours = () => {
 isSameHour.value = (
    !!timeslotRequest.value.start &&
    !!timeslotRequest.value.end &&
    timeslotRequest.value.start === timeslotRequest.value.end
  );
}

const isHourValid = () => {
 if (!timeslotRequest.value.start || !timeslotRequest.value.end) {
    isSameHour.value = false;
    return;
  }

  const startDate = parse(timeslotRequest.value.start, DateFormat.TIME_SMALL, new Date());
  const endDate = parse(timeslotRequest.value.end, DateFormat.TIME_SMALL, new Date());

  isSameHour.value = endDate < startDate || startDate > endDate;
}

watch(
    () => props.isOpen,
  () => {
    timeslotRequest.value = {
      timeslotId: props.timeslotId ?? null,
      start: props.start ?? null,
      end:props.end ?? null
    }

    deleteAction.value = false;
    isSameHours();
  }
);


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-container-day-model",
          ref_key: "target",
          ref: target
        }, [
          _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.displayDeleteButton && (_ctx.timeslotId || _ctx.isSetting))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('settings.label.dayModel.form.timeslot.delete'),
                      styles: "main-m"
                    }, null, 8, ["txt"])
                  ]),
                  _createVNode(_component_switchGroup, {
                    active: deleteAction.value,
                    class: "es-switch",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (updateDeleteAction()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: "check",
                        styles: "size-m",
                        class: _normalizeClass(deleteAction.value ? 'img-white' : '')
                      }, null, 8, ["class"])
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]))
              : _createCommentVNode("", true),
            (!deleteAction.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('settings.label.dayModel.form.timeslot.start'),
                        styles: "main-m"
                      }, null, 8, ["txt"])
                    ]),
                    _createVNode(_component_esInputDateTime, {
                      dateTimeValue: getDateTime(timeslotRequest.value.start),
                      dateFormat: _unref(DateFormat).TIME_LONG,
                      timeOnly: true,
                      minDate: _ctx.min,
                      maxDate: _ctx.max,
                      onUpdateDateTime: _cache[1] || (_cache[1] = ($event: any) => (updateTime($event, false)))
                    }, null, 8, ["dateTimeValue", "dateFormat", "minDate", "maxDate"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('settings.label.dayModel.form.timeslot.end'),
                        styles: "main-m"
                      }, null, 8, ["txt"])
                    ]),
                    _createVNode(_component_esInputDateTime, {
                      dateTimeValue: getDateTime(timeslotRequest.value.end ? timeslotRequest.value.end : timeslotRequest.value.start),
                      dateFormat: _unref(DateFormat).TIME_LONG,
                      timeOnly: true,
                      minDate: _ctx.min,
                      maxDate: _ctx.max,
                      onUpdateDateTime: _cache[2] || (_cache[2] = ($event: any) => (updateTime($event, true)))
                    }, null, 8, ["dateTimeValue", "dateFormat", "minDate", "maxDate"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_es_modal_footer, {
            onModalCancel: closeFormModal,
            confirmModalMethod: async () => await confirmFormModal(),
            confirmDisabled: isSameHour.value
          }, null, 8, ["confirmModalMethod", "confirmDisabled"])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}
}

})